import { APIConfig } from '../../api/api.config';
import { AuthConfig } from '../../plugins/auth/auth.config';
import { LogConfig } from '../../plugins/logger/log.config';

export type EnvVars = AuthConfig & LogConfig & APIConfig;

export function env<K extends keyof EnvVars>(envVar: K, fallback: EnvVars[K]): EnvVars[K] {
  return (import.meta.env[`VITE_${envVar}`] || window?.SERVER_DATA?.[envVar]) ?? fallback;
}
